/* istanbul ignore file */
// libs
import React, { RefObject } from 'react';
import LinkIcon from '@mui/icons-material/LinkOutlined';
// services
import { copyToClipboard } from 'framework/ui/clipboard';
import { useUiTheme } from 'framework/uiTheme';
import { Link } from '@mui/material';

const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
  e.preventDefault();
  copyToClipboard(e.currentTarget.href);
};

interface AnchorProps {
  link: string;
  id: string;
  classes?: string;
  children: React.ReactNode | React.ReactNode[];
  linkRef?: RefObject<HTMLAnchorElement>;
}

const Anchor = ({
  link,
  id,
  classes = '',
  children,
  linkRef = {
    current: null,
  },
}: AnchorProps) => {
  const { Tooltip } = useUiTheme();

  return (
    <Tooltip id={id} arrow placement="right" title={children}>
      <Link
        href={link}
        onClick={handleAnchorClick}
        id={id}
        className={`copy-anchor ${classes}`}
        ref={linkRef}
        sx={{
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          '& svg': {
            color: 'text.secondary',
            width: '21px',
            height: '21px',
            '&:hover': { color: 'text.primary' },
          },
          '&.timeline-anchor, &.section-anchor': {
            marginLeft: '8px',
            '& svg': {
              width: '22px',
              height: '22px',
              verticalAlign: 'middle',
            },
          },
          '&.section-anchor svg': { marginTop: '5px' },
          '&.one-stop-error__copy-anchor': {
            lineHeight: 'inherit',
            transform: 'translateY(-1px)',
          },
        }}
      >
        <LinkIcon />
      </Link>
    </Tooltip>
  );
};

export default Anchor;
